import { router } from "react-query-kit";
import { type FollowUserInput, followUser } from "./api/follow-user";
import { type GetFollowersInput, getFollowers } from "./api/get-followers";
import { type GetFollowingInput, getFollowing } from "./api/get-following";
import { type GetUserInput, getUser } from "./api/get-user";
import { type UnfollowUserInput, unfollowUser } from "./api/unfollow-user";
import { type UpdateAvatarInput, updateAvatar } from "./api/update-avatar";
import { type UpdateProfileInput, updateProfile } from "./api/update-profile";

export const userQueries = router("user", {
  followUser: router.mutation({
    mutationFn: (data: FollowUserInput) => followUser({ data }),
  }),
  getFollowing: router.query({
    fetcher: (data: GetFollowingInput) => getFollowing({ data }),
  }),
  getFollowers: router.query({
    fetcher: (data: GetFollowersInput) => getFollowers({ data }),
  }),
  getUser: router.query({
    fetcher: (data: GetUserInput) => getUser({ data }),
  }),
  unfollowUser: router.mutation({
    mutationFn: (data: UnfollowUserInput) => unfollowUser({ data }),
  }),
  updateAvatar: router.mutation({
    mutationFn: (data: UpdateAvatarInput) => updateAvatar({ data }),
  }),
  updateProfile: router.mutation({
    mutationFn: (data: UpdateProfileInput) => updateProfile({ data }),
  }),
});
